const translations = {
    fr: 
        {
            title: 'Sommaire',
            p1: 'Vous trouverez ici les tests classés par machine. Bonne lecture !',
        },
    uk: 
        {
            title: 'Summary',
            p1: 'Here you will find the tests sorted by platform. Enjoy reading!',
        },
    de: 
        {
            title: 'Inhaltsverzeichnis',
            p1: 'Hier finden Sie die Tests, sortiert nach Plattform. Viel Spaß beim Lesen!',
        },
    es: 
        {
            title: 'Resumen',
            p1: 'Aquí encontrarás las pruebas clasificadas por plataforma. ¡Buena lectura!',
        }
}

export default translations;